import React, { useContext, useEffect, useState } from 'react';
import { NavigateNext } from '@mui/icons-material';
import { Breadcrumbs, Tooltip, Typography, Link, Skeleton } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ActionPanelControlsReducer } from './actionPanel/helpers/actionPanelControlsReducer';
import { ActionPanelContext, BreadcrumbsContext, TitleContext } from '../contexts';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

const Header = () => {
  const { i18n } = useTranslation();

  const [renderedActionPanelComponent, setRenderedActionPanelComponent] = useState([]);

  const { actionPanelComponents, disabled } = useContext(ActionPanelContext);
  const { breadcrumbsItems, breadcrumbsLoading } = useContext(BreadcrumbsContext);
  const { title, titleLoading } = useContext(TitleContext);

  useEffect(() => {
    setRenderedActionPanelComponent(ActionPanelControlsReducer(actionPanelComponents, disabled));
  }, [actionPanelComponents, disabled]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <Box sx={{ mb: '0.2rem' }}>
        {titleLoading ? <Skeleton variant='text' width='18rem' height='3rem' /> : <Typography variant='h4'>{title}</Typography>}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        {breadcrumbsLoading ? (
          <Skeleton variant='text' width='10rem' />
        ) : (
          <Breadcrumbs
            maxItems={2}
            itemsBeforeCollapse={0}
            separator={<NavigateNext sx={{ rotate: i18n.language === 'ar' ? '180deg' : '' }} fontSize='xs' />}>
            {breadcrumbsItems?.map((breadcrumbItem, index) =>
              index === breadcrumbsItems?.length - 1 ? (
                <Tooltip title={breadcrumbItem.text} key={index}>
                  <Typography
                    sx={{
                      maxWidth: '40rem',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      textTransform: 'uppercase',
                    }}
                    noWrap={true}
                    color='inherit'
                    variant='caption'>
                    {breadcrumbItem.text}
                  </Typography>
                </Tooltip>
              ) : (
                <Link
                  component={RouterLink}
                  underline='hover'
                  color='gray'
                  to={breadcrumbItem.pathname}
                  key={index}
                  onClick={breadcrumbItem.onClick}
                  {...(breadcrumbItem.props ?? {})}>
                  <Typography key={index} variant='caption' sx={{ textTransform: 'uppercase' }}>
                    {breadcrumbItem.text}
                  </Typography>
                </Link>
              ),
            )}
          </Breadcrumbs>
        )}
        <Box sx={{ display: 'flex', alignItems: 'flex-end', width: 'fit-content', gap: '1rem' }}>{renderedActionPanelComponent}</Box>
      </Box>
    </Box>
  );
};

export default Header;
